import {ErrorDataset} from './ErrorDataset';
import {ErrorChartLabel} from './ErrorChartLabel';

export class ErrorChartData {
    labels: ErrorChartLabel[];
    datasets: ErrorDataset[];

    constructor(labels: ErrorChartLabel[], datasets: ErrorDataset[]) {
        this.labels = labels;
        this.datasets = datasets;
    }
}
